import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TankBook } from './tank-book';

@Injectable({
  providedIn: 'root'
})
export class TankBooksService {

  private basePath = "api/v1/";
  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    if ( error.error && this.isJson(error.error) ) {
      return Promise.reject(JSON.parse(error.error));
    }
    return Promise.reject(error.message || error);
  }

  private isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  get(tankId: string, groupBy: boolean, startDate: number, endDate: number): Promise<any> {
    let url = this.basePath + "tank_book/" + tankId;
    let params = new HttpParams();
    params = params.append('groupBy', groupBy.toString())
      .append('startDate', startDate.toString())
      .append('endDate', endDate.toString());
    return this.http.get(url, { params: params })
      .toPromise()
      .then( res => res as TankBook[])
      .catch( error => this.errorHandler(error) );
  }

  getSeries(tankId: string, startDate: number, endDate: number): Promise<any> {
    let url = this.basePath + "tank_book/" + tankId + "/series";
    let params = new HttpParams();
    params = params.append('startDate', startDate.toString())
      .append('endDate', endDate.toString());
    return this.http.get(url, { params: params })
      .toPromise()
      .then( res => res as TankBook[])
      .catch( error => this.errorHandler(error) );
  }

}
